import React from 'react';
import PropTypes from 'prop-types';

import {Stack, Typography, Box} from 'views/components';
import {Translate} from 'views/module';

const Content = (props) => {
  const careviewItem = props.careviewItem;
  const setEditMode = props.setEditMode;

  const questionTitle = careviewItem.questionData.questionTitle;
  const enabledOnYes = careviewItem.questionData.followUpYesNo.enabledOnYes;
  const enabledOnNo = careviewItem.questionData.followUpYesNo.enabledOnNo;

  return (
    <Stack
    >
      <Box
        sx={{
          '&:hover': {
            cursor: 'pointer',
          },
        }}
        onClick={setEditMode}
      >
        <Stack spacing={1}>
          <Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                }}
              >
                <Translate
                  expression='client.ClientDetail.CareviewSettings.Types.YesNo.Question'
                />
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: '16px',
                }}
              >
                {questionTitle}
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                }}
              >
                <Translate
                  expression='client.ClientDetail.CareviewSettings.Types.YesNo.FollowupEnabledYes'
                />
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: '16px',
                }}
              >
                <Translate
                  expression={
                    enabledOnYes ?
                      'client.ClientDetail.CareviewSettings.Types.YesNo.Enabled' :
                      'client.ClientDetail.CareviewSettings.Types.YesNo.Disabled'
                  }
                />
              </Typography>
            </Box>
          </Box>
          <Box>
            <Box>
              <Typography
                sx={{
                  fontWeight: 600,
                  fontSize: '18px',
                }}
              >
                <Translate
                  expression='client.ClientDetail.CareviewSettings.Types.YesNo.FollowupEnabledNo'
                />
              </Typography>
            </Box>
            <Box>
              <Typography
                sx={{
                  fontSize: '16px',
                }}
              >
                <Translate
                  expression={
                    enabledOnNo ?
                      'client.ClientDetail.CareviewSettings.Types.YesNo.Enabled' :
                      'client.ClientDetail.CareviewSettings.Types.YesNo.Disabled'
                  }
                />
              </Typography>
            </Box>
          </Box>
        </Stack>
      </Box>
    </Stack>
  );
};

Content.propTypes = {
  careviewItem: PropTypes.object.isRequired,
  setEditMode: PropTypes.func.isRequired,
};
export default React.memo(Content);
